export default __webpack_public_path__ + "locales/pt/Translations.json?hash=9d3074807afcbb601b3cadf89ccd7e73";